<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main meterial_main">
        <!-- <SubTitleComponent :title="title"></SubTitleComponent> -->
        <div class="box">
          <!-- <div class="filter">
            <el-row :gutter="10">
              <el-col :span="6">
                <div class="grid-content">
                  <el-input
                    placeholder="请输入内容"
                    prefix-icon="el-icon-search"
                    v-model="searchInput">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="4" :offset="14"><el-button icon="el-icon-right" type="success" @click="toPerson"><span class="btn">收藏的素材</span></el-button></el-col>
            </el-row>
          </div> -->
          <div class="tag">
            <el-row :gutter="10">
              <el-col :span="20">
                <el-radio-group v-model="type" @change="typeChange">
                  <div class="type_box">
                    <el-radio-button :label="'风格'"></el-radio-button>
                    <el-radio-button :label="'空间类型'"></el-radio-button>
                    <el-radio-button :label="'公司案例'"></el-radio-button>
                    <el-radio-button :label="'项目案例'"></el-radio-button>
                  </div>
                </el-radio-group>
              </el-col>
              <el-col :span="4"><el-button style="margin: 15px 0 15px;" icon="el-icon-right" type="success" @click="toPerson"><span class="btn">收藏的素材</span></el-button></el-col>
            </el-row>
            <el-row>
              <!-- <el-col :span="4" style="padding-right:20px">
                <el-tag type="success" class="label" effect="light">风格</el-tag>
              </el-col> -->
              <el-col v-if="type == '风格'" :span="20" class="tag_main">
                <el-tag :type="-1 == styleCur ? 'success' : 'info'" :class="'all_item'" @click="styleClick(-1)" :effect="'light'">全部</el-tag>
                <el-tag :type="index == styleCur ? 'success' : 'info'" v-for="(item, index) in styleData" :key="'style'+index" :effect="'light'" @click="styleClick(index)">{{ item.style_type }}</el-tag>
              </el-col>
              <el-col v-if="type == '空间类型'" :span="20" class="tag_main">
                <el-tag :type="-1 == spaceCur ? 'success' : 'info'" :class="'all_item'" @click="spaceClick(-1)" :effect="'light'">全部</el-tag>
                <el-tag :type="index == spaceCur ? 'success' : 'info'" v-for="(item, index) in spaceData" :key="'space'+index" :effect="'light'" @click="spaceClick(index)">{{ item.space_type }}</el-tag>
              </el-col>
              <el-col v-if="type == '公司案例'" :span="20" class="tag_main">
                <el-tag :type="-1 == companyCur ? 'success' : 'info'" :class="'all_item'" @click="companyClick(-1)" :effect="'light'">全部</el-tag>
                <el-tag :type="index == companyCur ? 'success' : 'info'" v-for="(item, index) in companyData" :key="'company'+index" :effect="'light'" @click="companyClick(index)">{{ item.project_type }}</el-tag>
              </el-col>
              <el-col v-if="type == '项目案例'" :span="20" class="tag_main">
                <el-tag :type="-1 == projectCur ? 'success' : 'info'" :class="'all_item'" @click="projectClick(-1)" :effect="'light'">全部</el-tag>
                <el-tag :type="index == projectCur ? 'success' : 'info'" v-for="(item, index) in projectData" :key="'project'+index" :effect="'light'" @click="projectClick(index)">{{ item.project_type }}</el-tag>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="4" style="padding-right:20px">
                <el-tag type="success" class="label" effect="light">空间类型</el-tag>
              </el-col>
              <el-col :span="20" class="tag_main">
                <el-tag :type="-1 == spaceCur ? 'success' : 'info'" :class="'all_item'" @click="spaceClick(-1)" :effect="'light'">全部</el-tag>
                <el-tag :type="index == spaceCur ? 'success' : 'info'" v-for="(item, index) in spaceData" :key="'space'+index" :effect="'light'" @click="spaceClick(index)">{{ item.space_type }}</el-tag>
              </el-col>
            </el-row> -->
          </div>
          <!-- <div class="list_box" ref="listBox" :style="'height:'+listTop+'px'"> -->
          <!-- <div v-if="meterialData.length > 0" v-loading="loadType" class="list_box" ref="listBox" v-infinite-scroll="getMeterial" infinite-scroll-distance="100" infinite-scroll-delay="100" infinite-scroll-immediate="false"> -->
          <div v-if="meterialData.length > 0" v-loading="loadType" class="list_box" ref="listBox">
            <!-- <ul class="list" v-if="meterialData.length > 0" v-infinite-scroll="getMeterial" infinite-scroll-distance="50">
              <li v-for="(item, index) in meterialData" :key="'meterial'+index" class="item" @click="toDetail(index)">
                <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="">
                <div class="name">{{ index + 1 }}</div>
              </li>
            </ul> -->
            <div>
              <waterfall :col="5" height="600px" :gutterWidth="20" :data="meterialData" :loadDistance="200" @loadmore="getMeterial" @scorll="waterScroll" @finish="loadFinish">
                <template>
                  <div v-for="(item, index) in meterialData" :key="'meterial'+index" class="item" @click="toDetail(index)">
                    <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="">
                    <!-- <div class="name">{{ index + 1 }}</div> -->
                    <div v-if="type == '公司案例' || type == '项目案例'" class="name">{{ item.company }}</div>
                    <div class="item_tag">
                      <span v-for="itemS,indexS in item.tag">{{ itemS }}{{ indexS < item.tag.length - 1 ? '&nbsp;/&nbsp;' : '' }}</span>
                    </div>
                  </div>
                </template>
              </waterfall>
            </div>
          </div>
          <div class="list" v-if="meterialData.length <= 0">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
        <el-dialog
          v-if="dialogVisible == 'detail_img'"
          custom-class="pop_img"
          :visible.sync="dialogVisit"
          top="15vh"
          :show-close="false"
          :center="true"
          :beforeClose="closeDetail">
          <div class="img" v-if="dialogCur != -1">
            <img :src="dialogImg" alt="">
          </div>
          <div v-if="dialogCur > 0" class="arrow left" @click="arrowClick(-1)"></div>
          <div v-if="dialogCur < meterialData.length - 1" class="arrow right" @click="arrowClick(1)"></div>
        </el-dialog>
        <el-dialog
          v-if="dialogVisible == 'detail'"
          :visible.sync="dialogVisit"
          top="10vh"
          width="90%"
          center>
          <!-- <img v-if="dialogCur != -1" :src="meterialData[dialogCur].photo_url" alt=""> -->
          <el-row :gutter="20" class="detail_box row">
            <el-col :span="14">
              <div class="img" v-if="dialogCur != -1">
                <img v-if="type == '风格' || type == '空间类型'" :src="detailData.photo_url" @click="toDetailImg(dialogCur, 1)" alt="">
                    {{ detailData.photo }} ------
                <div class="swiper-container" v-if="type == '公司案例' || type == '项目案例'">
                  <div style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff" class="swiper mySwiper2">
                    <div class="swiper-wrapper">
                      <div v-for="item in detailData.photo" :key="item.photo_url" class="swiper-slide">
                        <img :src="item.photo_url" />
                      </div>
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                  </div>
                  <div thumbsSlider="" class="swiper mySwiper">
                    <div class="swiper-wrapper">
                      <div v-for="item in detailData.photo" :key="item.photo_url" class="swiper-slide">
                        <img :src="item.photo_url" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="10" v-if="dialogCur != -1">
              <div v-if="type == '风格' || type == '空间类型'" class="list">
                <div class="item title">基本信息</div>
                <div class="item" v-if="detailData.client_name != ''">
                  <div class="label">客户名称</div>
                  <div class="content">{{ detailData.client_name }}</div>
                </div>
                <div class="item">
                  <div class="label">空间类型</div>
                  <div class="content">{{ detailData.space_type }}</div>
                </div>
                <div class="item">
                  <div class="label">风格</div>
                  <div class="content">{{ detailData.style_type }}</div>
                </div>
                <div class="item">
                  <div class="label">贡献者</div>
                  <div class="content">{{ detailData.author_name_en }}</div>
                </div>
                <div class="item">
                  <div class="label">上传时间</div>
                  <div class="content date">{{ detailData.createtime }}</div>
                </div>
              </div>
              <div v-if="type == '公司案例' || type == '项目案例'" class="list">
                <div class="item title">{{ detailData.company }}</div>
                <div class="item">
                  {{ detailData.design_concept }}
                </div>
                <div class="item">
                  <div class="label">项目名称</div>
                  <div class="content">{{ detailData.project_name }}</div>
                </div>
                <div class="item">
                  <div class="label">项目地址</div>
                  <div class="content">{{ detailData.project_address }}</div>
                </div>
                <div class="item">
                  <div class="label">项目面积</div>
                  <div class="content">{{ detailData.project_area }}平方米</div>
                </div>
                <div class="item">
                  <div class="label">标签类型</div>
                  <div class="content">
                    <span v-for="value, index in detailData.tag">
                      <span v-if="index == detailData.tag.length - 1">{{ value }}</span>
                      <span v-if="index < detailData.tag.length - 1">{{ value }}&nbsp;/&nbsp;</span>
                    </span>
                  </div>
                </div>
                <div class="item">
                  <div class="label">项目类型</div>
                  <div class="content date">{{ detailData.project_type }}</div>
                </div>
                <div class="item" v-if="type == '项目案例'">
                  <div class="label">设计师</div>
                  <div class="content date">{{ detailData.designer }}</div>
                </div>
                <el-button @click="toGenerate(dialogCur)" type="success">应用同款</el-button>
              </div>
            </el-col>
          </el-row>
          <span v-if="type == '风格' || type == '空间类型'" slot="footer" class="dialog-footer">
            <el-button @click="toGenerate(dialogCur)">生成同款</el-button>
            <el-button v-if="dialogCur >= 0" type="success" @click="toCollect(dialogCur)">{{ detailData.user_material_id == 0 ? '收藏' : '取消收藏' }}</el-button>
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>

import Swiper from 'swiper'
import 'swiper/css/swiper.css'

const style_data = [
  {
    "material_style_id": 0,
    "style_type": "现代"
  },
  {
    "material_style_id": 0,
    "style_type": "简约"
  },
  {
    "material_style_id": 0,
    "style_type": "奢华"
  },
  {
    "material_style_id": 0,
    "style_type": "新中式"
  },
  {
    "material_style_id": 0,
    "style_type": "北欧"
  },
  {
    "material_style_id": 0,
    "style_type": "工业风"
  },
  {
    "material_style_id": 0,
    "style_type": "复古"
  },
  {
    "material_style_id": 2,
    "style_type": "抽象"
  }
]

const space_data = [
  {
    "material_space_id": 0,
    "space_type": "现代"
  },
  {
    "material_space_id": 0,
    "space_type": "简约"
  },
  {
    "material_space_id": 0,
    "space_type": "奢华"
  },
  {
    "material_space_id": 0,
    "space_type": "新中式"
  },
  {
    "material_space_id": 0,
    "space_type": "北欧"
  },
  {
    "material_space_id": 0,
    "space_type": "工业风"
  },
  {
    "material_space_id": 0,
    "space_type": "复古"
  },
  {
    "material_space_id": 2,
    "space_type": "抽象"
  }
]

const meterial_data = [
  {
    "material_id": 2,
    "photo_url": "https://ylww.oss-cn-shenzhen.aliyuncs.com/attachment/20250519/202505191439123531.jpg",
    "style_type": "北欧",
    "space_type": "展厅"
  },
  {
    "material_id": 1,
    "photo_url": "https://ylww.oss-cn-shenzhen.aliyuncs.com/attachment/20250519/202505191439123531.jpg",
    "style_type": "现代",
    "space_type": "展厅"
  }
]

let styleType = 0
let spaceType = 0
let _ajaxType = 0

let getColumnList = (list, columnsNum = 5) => {
  const arrObject = {}
  for(let i = 0; i < columnsNum; i++){
    arrObject[i] = []
  }
  list.forEach((element, index) => {
    element.id = `${index+1}`;
  });
  list.forEach((element, index) => arrObject[index % columnsNum].push(element));
  console.log('list', list)
  const cloGapList = []
  for(let key in arrObject){
    cloGapList.push(...arrObject[key])
  }
  console.log('cloGapList', cloGapList)
  return cloGapList
}

export default {
  name: 'Material',
  components: {},
  data() {
    return {
      title: '素材库',
      searchInput: '',
      type: '风格',
      typeData: [],
      styleData: [],
      styleCur: -1,
      spaceData: [],
      spaceCur: -1,
      companyData: [],
      companyCur: -1,
      projectData: [],
      projectCur: -1,
      meterialData: [],
      dialogVisible: '',
      dialogVisit: false,
      dialogCur: -1,
      dialogType: '',
      page: 0,
      pagesize: 100,
      allpage: 0,
      listTop: 0,
      detailData: {
        client_name: '',
        space_type: '',
        style_type: '',
        update_time: '',
        author_name_en: '',
        createtime: '',
        img_url: '',
        user_material_id: 0
      },
      loadType: true,
      slides: [1, 2, 3, 4, 5], // 示例幻灯片数据
      mySwiper: null,
      thumbsSwiper: null,
    }
  },
  mounted() {
    _ajaxType = 0
    this.getData()
  },
  methods: {
    closeDetail(e) {
      console.log('dialogType', this.dialogType)
      this.dialogImg = ''
      console.log('dialogCur', this.dialogCur)
      if(this.dialogType == 'img'){
        this.dialogType = ''
        this.dialogVisible = 'detail'
        return
      }
      if(this.dialogType != 'img'){
        this.detailData['photo_url'] = ''
        this.dialogCur = -1
        this.dialogVisit = false
        this.dialogVisible = ''
      }
      e()
    },
    getData() {
      // this.styleData = style_data
      // this.spaceData = space_data
      // this.meterialData = meterial_data
      this.getDeploy()
    },
    getTypeData() {
    },
    getDeploy() {
      let _url = "/api/?mod=deploy"
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("styleData", _data);
        if (json.data.errcode == 0) {
          this.styleData = _data.style
          this.spaceData = _data.space
          this.companyData = _data.case_project_type1
          this.projectData = _data.case_project_type2
          this.getMeterial()
        }
        console.log(json.data);
      })
    },
    getMeterial() {
      console.log('getMeterial')
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      let _type = this.type
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        this.loadType = true
        _ajaxType = 1
        let _url = "/api/?mod=material"
        let _styleCur = this.styleCur
        let _style = ''
        if(this.styleCur != -1){
          _style = this.styleData[_styleCur].style_type
        }
        let _space = ''
        if(this.spaceCur != -1){
          _space = this.spaceData[this.spaceCur].space_type
        }
        let _clientData = {
          page: _page + 1,
          pagesize: this.pagesize,
          type: 0,
          style_type: _style,
          space_type: _space
        }
        if(_type == '公司案例'){
          _url = '/api/?mod=case'
          _clientData['case_type'] = 1
          let _company = ''
          if(this.companyCur != -1){
            _company = this.companyData[this.companyCur].project_type
          }
          _clientData['project_type'] = _company
        }
        if(_type == '项目案例'){
          _url = '/api/?mod=case'
          _clientData['case_type'] = 2
          let _project = ''
          if(this.projectCur != -1){
            _project = this.projectData[this.projectCur].project_type
          }
          _clientData['project_type'] = _project
        }
        this.axios.post(_url, _clientData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("materialData", _data);
          if (json.data.errcode == 0) {
            this.page = _data.page
            this.allpage = _data.allpage
            // let _material = getColumnList(_material, 5)
            this.meterialData = [...this.meterialData, ..._data.result]
            // this.getHeight()
          }
          console.log(json.data);
        })
      }
    },
    getHeight() {
      let _listbox = this.$refs.listBox
      console.log('listbox', _listbox)
      console.log('listbox', _listbox.offsetTop)
      this.listTop = window.innerHeight - _listbox.offsetTop - 30
      console.log('listbox', _listbox.scrollHeight)
    },
    toDetail(cur) {
      let _type = this.type
      if(_type == '公司案例' || _type == '项目案例'){
        let _url = '/api/?mod=case&action=detail'
        let _id = this.meterialData[cur].case_id
        console.log(this.meterialData, cur, _id)
        let _clientData = {
          case_id: _id
        }
        this.axios.post(_url, _clientData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("projectDetail", _data);
          if (json.data.errcode == 0) {
            this.detailData = _data
          }
          this.dialogVisible = 'detail'
          this.dialogCur = 0
          this.dialogVisit = true
          setTimeout(() => {
            // 延迟触发，需要等待页面加载完成后才能触发方法，不然无效
            this.initSwiper()
          }, 200)
          // console.log(json.data);
        })
        return
      }
      this.detailData = this.meterialData[cur]
      this.dialogVisible = 'detail'
      this.dialogCur = [cur]
      this.dialogVisit = true
    },
    toDetailImg(cur, type) {
      let _img = this.meterialData[cur].photo_url
      if(type == 1){
        this.dialogType = 'img'
        // _img = this.meterialData[cur].effect_result[0].file_url
      }
      this.dialogImg = _img
      this.dialogVisit = true
      this.dialogVisible = 'detail_img'
    },
    toGenerate(cur) {
      console.log(cur)
      let _material = this.meterialData[cur]
      let _type = this.type
      let _photo = ''
      localStorage.setItem('material_type', _type)
      if(_type == '公司案例' || _type == '项目案例'){
        // console.log(this.mySwiper.realIndex)
        console.log(this.thumbsSwiper.realIndex)
        let _index = this.thumbsSwiper.realIndex
        _photo = this.detailData.photo[_index].photo_url
        let _id = this.detailData.case_id
        localStorage.setItem('case_id', _id)
        localStorage.setItem('material_url', _photo)
        this.$router.push({ path: '/effectsave' })
        return
      }
      let _style = _material.style_type
      let _space = _material.space_type
      _photo = _material.photo_url
      localStorage.setItem('material_url', _photo)
      localStorage.setItem('material_style', _style)
      localStorage.setItem('material_space', _space)
      this.$router.push({ path: '/effectsave' })
    },
    toCollect(cur) {
      console.log(cur)
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=material&action=favorite"
      let _material = [...this.meterialData]
      let _type = _material[cur].user_material_id == 0
      let _id = _material[cur].material_id
      if(_type == false){
        _url = "/api/?mod=material&action=delete"
        _id = _material[cur].user_material_id
      }
      let _collectData = {
        material_id: _id
      }
      this.axios.post(_url, _collectData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("collect", _data);
        if (json.data.errcode == 0) {
          let _content = '收藏成功'
          let _id = 0
          if(_type == true){
            _id = _data.user_material_id
          }
          if(_type == false){
            _content = '取消收藏成功'
          }
          _material[cur].user_material_id = _id
          this.detailData['user_material_id'] = _id
          this.meterialData = _material
          this.$message({
            message: _content,
            type: 'success'
          });
        }
        // console.log(json.data);
      })
    },
    toPerson() {
      this.$router.push({ path: '/materialperson' })
    },
    styleClick(cur) {
      console.log(cur)
      this.page = 0
      this.allpage = 0
      _ajaxType = 0
      this.styleCur = cur
      this.meterialData = []
      this.loadType = true
      this.getMeterial()
    },
    spaceClick(cur) {
      console.log(cur)
      this.page = 0
      this.allpage = 0
      _ajaxType = 0
      this.spaceCur = cur
      this.loadType = true
      this.meterialData = []
      this.getMeterial()
    },
    companyClick(cur) {
      console.log(cur)
      this.page = 0
      this.allpage = 0
      _ajaxType = 0
      this.companyCur = cur
      this.loadType = true
      this.meterialData = []
      this.getMeterial()
    },
    projectClick(cur) {
      console.log(cur)
      this.page = 0
      this.allpage = 0
      _ajaxType = 0
      this.projectCur = cur
      this.loadType = true
      this.meterialData = []
      this.getMeterial()
    },
    loadmore() {
      this.getMeterial()
    },
    arrowClick(num) {
      let nowCur = this.dialogCur
      let _cur = parseInt(nowCur) + num
      if(_cur < 0 || _cur > this.meterialData.length - 1) return
      console.log('arrowClick', this.dialogCur, num, _cur)
      this.dialogImg = this.meterialData[_cur].photo_url
      console.log(this.dialogImg, this.meterialData[_cur].photo_url)
      this.detailData = this.meterialData[_cur]
      this.dialogCur = _cur
    },
    waterScroll(e) {
      console.log('waterScroll------------------------', e)
    },
    loadFinish() {
      console.log('loadFinish++++++++++++++++++++')
      this.loadType = false
    },
    typeChange(e) {
      this.page = 0
      this.meterialData = []
      this.loadType = true
      this.getMeterial()
    },
    initSwiper() {
      console.log('initSwiper-------------')
      this.mySwiper = new Swiper(".mySwiper", {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });
      this.thumbsSwiper = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: this.mySwiper,
        },
      });
    },
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    // background: #fff;
    box-sizing: border-box;
    .filter {
      background: #fff;
      padding: 10px;
      margin-bottom: 20px;
      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        background: #fff;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }
      .el-button {
        width: 100%;
      }
    }
    .tag {
      background: #fff;
      padding: 10px 20px;
      .el-button {
        width: 100%;
      }
    }
    .type_box {
      margin: 10px 0 20px;
      .el-radio-button {
        width: 150px;
        height: 50px;
      }
    }
    .tag_main {
      position: relative;
      // padding-left: 90px;
      vertical-align: top;
      font-size: 0;
      .all_item {
        // position: absolute;
        // top: 0;
        // left: 0;
        // background: transparent;
        border: 0;
      }
      .tag_box {
        display: inline-block;
      }
    }
    .el-tag {
      margin: 0 16px 16px 0;
      // padding: 0 20px;
      // border: 0;
      height: 30px;
      // color: rgba(10,10,10,1);
      font-size: 18px;
      line-height: 30px;
      border: 0;
      &.el-tag--info {
        background: transparent;
      }
      &.label {
        width: 100%;
        text-align: center;
        // font-size: 24px;
        // font-weight: 700;
      }
      &.on {
        // font-size: 24px;
        // font-weight: 700;
      }
    }
    .list_box {
      // height: 100%;
      margin-top: 20px;
      // overflow: auto;
      // scrollbar-width: none;
      // -ms-overflow-style: none;
      .item {
        position: relative;
        // display: inline-block;
        // width: 100%;
        // flex: 0 0 calc(30%);
        // float: left; /* 使用浮动实现水平排列 */
        // width: 100%;
        height: auto;
        // writing-mode: horizontal-tb;
        break-inside: avoid-column; /* 防止内容在列中断开 */
        page-break-inside: avoid;
        margin-bottom: 20px;
        // padding: 10px;
        // background: #fff;
        // border: 1px dashed rgb(187, 187, 187);
        border-radius: 5px;
        box-sizing: border-box;
        font-size: 0;
        .name {
          margin-top: 10px;
          font-size: 16px;
          text-align: center;
        }
        .item_tag {
          margin-top: 5px;
          font-size: 16px;
          text-align: center;
        }
        img {
          width: 100%;
          border-radius: 4px;
          // aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          // object-fit: cover;
        }
      }
    }
    ul.list {
      // height: 100%;
      // display: block;
      margin-block-start: 0;
      padding-inline-start: 0;
      margin-top: 20px;
      // display: grid;
      // grid-template-columns: repeat(5, 1fr);
      // padding-inline-start: 0;
      // gap: 20px;
      column-count: 5; /* 设置列数 */
      column-gap: 20px; /* 设置列间距 */
      // column-fill: auto; /* 控制列填充方式 */
      // writing-mode: vertical-lr;
      // direction: rtl;
      // padding: 0 30px;
      vertical-align: top;
      list-style: none;
      font-size: 0;
      li {
        position: relative;
        // display: inline-block;
        // width: 100%;
        // flex: 0 0 calc(30%);
        // float: left; /* 使用浮动实现水平排列 */
        // width: 100%;
        height: auto;
        // writing-mode: horizontal-tb;
        break-inside: avoid-column; /* 防止内容在列中断开 */
        page-break-inside: avoid;
        margin-bottom: 20px;
        padding: 10px;
        background: #fff;
        // border: 1px dashed rgb(187, 187, 187);
        border-radius: 5px;
        box-sizing: border-box;
        font-size: 0;
        img {
          width: 100%;
          // aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          // object-fit: cover;
        }
      }
    }
  }
  .detail_box {
    display: flex;
    // flex-direction: column;
    .img {
      font-size: 0;
      img {
        max-width: 100%;
        max-height: 50vh;
        border-radius: 10px;
      }
      video {
        max-width: 100%;
        max-height: 50vh;
      }
    }
    .list {
      display: grid;
      grid-template-rows: 50px;       /* 首行高度80px */
      // grid-auto-rows: minmax(60px, 1fr);
      // grid-auto-rows: minmax(calc(100%/7), 1fr);
      gap: 10px;
      height: 100%;
      padding: 20px;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #eee;
      border-radius: 10px;
      .item {
        height: 100%;
        border-bottom: 1px solid #eee;
        .label {
          display: flex;
          width: 35%;
          height: 100%;
          float: left;
          font-size: 18px;
          line-height: 26px;
          align-items: center;
          span {
            display: inline-block;
          }
        }
        .content {
          display: flex;
          width: 65%;
          height: 100%;
          float: right;
          font-size: 18px;
          line-height: 26px;
          justify-items: right;
          align-items: center;
          &.date {
            font-size: 16px;
          }
        }
        &.title {
          font-size: 24px;
          font-weight: 700;
          height: auto;
        }
        &:last-child {
          border: 0;
        }
      }
    }
  }
}
.el-dialog {
  .img {
    text-align: center;
    img {
      max-width: 100%;
      max-height: 60vh;
    }
  }
}
.pop_img {
  .img {
    font-size: 0;
    text-align: center;
    img {
      // max-width: 100%;
      // max-height: 70vh;
      // object-fit: contain;
      max-width: 90vw;
      max-height: 70vh;
      object-fit: contain;
    }
  }
  .arrow {
    position: fixed;
    top: 50%;
    width: 50px;
    height: 50px;
    background-size: auto 100%;
    background-position: center;
    background-repeat: no-repeat;
    &.left {
      left: 50px;
      background-image: url(../../assets/ico_arrow_left_2.png);
    }
    &.right {
      right: 50px;
      background-image: url(../../assets/ico_arrow_right_2.png);
    }
  }
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: 80%;
  width: 100%;
}

.mySwiper {
  width: 80%;
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}

.mySwiper .swiper-slide {
  width: 20%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-button-prev,
.swiper-button-next {
  top: auto;
  bottom: 12px;
  color: #000;
}

.swiper-container-thumbs img {
  height: 50px;
  aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
  object-fit: cover;
}

.vue-waterfall {
  height: calc(100vh - 326px) !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Material/Index.vue